export class AuditPackageGenerateRiskRequest {
  projectIds: number[];
  auditPackageItemIds: number[];
  auditPackageIds: number[];
  packageName: string;
  memberId: number;
  auditPackageId: number;

  constructor(options: {
    projectIds: number[];
    auditPackageItemIds: number[];
    auditPackageIds: number[];
    packageName: string;
    memberId: number;
    auditPackageId: number;
  }) {
    this.projectIds = options.projectIds;
    this.auditPackageItemIds = options.auditPackageItemIds;
    this.auditPackageIds = options.auditPackageIds;
    this.packageName = options.packageName;
    this.memberId = options.memberId;
    this.auditPackageId = options.auditPackageId;
  }
}
